import { formatIstDate } from '../../../../utils/helpers/istDate';
export const getCurrentFY = () => {
    const now = new Date();
    const year = now.getMonth() >= 3 ? now.getFullYear() : now.getFullYear() - 1;
    return `${year}-${year + 1}`;
};

export const fyDateRange = (fy) => {
    const [a, b] = (fy || '').split('-');
    if (!a || !b) return { from: '', to: '' };
    return { from: `${a}-04-01`, to: `${b}-03-31` };
};

export const fyShortLabel = (fy) => {
    if (!fy) return '';
    const [a, b] = fy.split('-');
    if (!a || !b) return fy;
    return `${a}-${String(b).slice(-2)}`;
};

export const formatCurrency = (amount, opts = {}) => {
    const value = parseFloat(amount);
    if (Number.isNaN(value)) return '-';
    if (opts.dashOnZero && value === 0) return '-';
    return value.toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

export const formatDate = (date) => formatIstDate(date);
